import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=1b2d2ab0&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=1b2d2ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d2ab0",
  null
  
)

export default component.exports